import { readDailyStatus } from '../../lib/dailyStatus'
import { mirrorChips } from '../../lib/home'

export type ComparisonScoreLabels = Record<string, { title: string; technical: string }>

const word = (value: string | null | undefined): string | undefined =>
  value != null && value.trim() !== '' ? value : undefined

/** Exact score-key lookups from the compared reading, never ingredient mappings. */
export function comparisonScoreLabels(raw: unknown, recordingId: string): ComparisonScoreLabels {
  const labels: ComparisonScoreLabels = Object.create(null)
  const result = readDailyStatus(raw)
  if (!result.readable || result.sessionId !== recordingId) return labels

  for (const score of result.scores) {
    const display = score.display
    if (display === null) continue
    const title = word(display.userTitle) ?? word(display.shortTitle) ?? word(display.title)
    if (title !== undefined) labels[score.slot] = { title, technical: display.title }
  }

  for (const chip of mirrorChips({
    recordingId, sessionDate: result.sessionDate ?? '', result, directionLabels: null,
  })) {
    if (!Object.hasOwn(labels, chip.key) && word(chip.title) !== undefined) {
      labels[chip.key] = { title: chip.title, technical: chip.title }
    }
  }
  return labels
}
